import Vue from 'vue'
import Vuex from 'vuex'

import authModule from './modules/auth'
import clientModule from './modules/client'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  modules: {
    auth: authModule,
    client: clientModule
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js